module.exports = __webpack_public_path__ + "img/ring_y_0_0_1@3x.34c5a8d6.png";